"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
// @todo: write types instead of any
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebDevice = void 0;
const tslib_1 = require("tslib");
const log_client_1 = require("@video/log-client");
const bowser_1 = tslib_1.__importDefault(require("bowser"));
const feature_1 = require("../../api/adapter/features/feature");
const api_1 = require("../../api");
const user_interaction_1 = require("../utils/user-interaction");
const user_agent_1 = require("./utils/user-agent");
const globalScope = (_a = globalThis) !== null && _a !== void 0 ? _a : (function fn() {
    return this;
})();
const HLSJS_URL = (_b = process.env.HLSJS_URL) !== null && _b !== void 0 ? _b : "https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.4.14/hls.min.js"; // This seems like a not a great idea.
if (process.env.HLSJS_BUNDLED !== "false") {
    // eslint-disable-next-line global-require
    globalScope.Hls = require("hls.js");
}
const MPEGTS_URL = (_c = process.env.MPEGTS_URL) !== null && _c !== void 0 ? _c : "https://cdn-us.threadsafesystems.com/mpegts.min.js"; // This seems like a not a great idea.
if (process.env.MPEGTS_BUNDLED !== "false") {
    try {
        // eslint-disable-next-line global-require
        globalScope.mpegts = require("mpegts.js");
    }
    catch (err) {
        // pass
    }
}
class NotSupportedError extends Error {
    constructor(prop, err) {
        super(`${prop} is not supported. ${err || ""}`);
    }
}
class WebDevice {
    constructor() {
        var _a, _b;
        this.hadUserInteraction = false;
        this.canvasElement = null;
        this.highEntropyValues = null;
        this.platform = null;
        this.appVersion = null;
        this.browserName = null;
        this.setTimeout = setTimeout.bind(globalScope);
        // setInterval = setInterval.bind(globalScope);
        this.clearTimeout = clearTimeout.bind(globalScope);
        this.clearInterval = clearInterval.bind(globalScope);
        const estimateFunc = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.estimate;
        if (typeof estimateFunc === "function") {
            this.storageEstimate = estimateFunc.bind(globalScope.navigator.storage);
        }
        this.logger = new log_client_1.LoggerCore("VDC-core").setLoggerMeta("client", "VDC").appendChain(WebDevice);
        if (!globalScope) {
            this.logger.error("globalScope is undefined");
        }
        if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator)) {
            this.logger.info("globalScope navigator is undefined");
        }
        if (typeof globalScope.__VDC_VARS__ !== "object") {
            globalScope.__VDC_VARS__ = new Map();
        }
        this.globals = globalScope.__VDC_VARS__;
        if (this.isImplements(feature_1.Feature.CREATE_CANVAS_ELEMENT)) {
            this.canvasElement = this.createCanvasElement();
        }
        this.getUserAgentInfo();
    }
    /**
     * @todo this can possibly be deprecated
     *  */
    applyUserInteractionHook() {
        const options = { silentAudio: { playSilentAudio: true, infiniteLoop: false } };
        const userInteraction = new user_interaction_1.UserInteraction(options);
        globalScope.document.addEventListener("beforeunload", userInteraction.dispose);
    }
    toggleCameraVisibility(msc) {
        if (this.isIosDevice) {
            msc.videoPaused = !msc.videoPaused;
        }
        else {
            if (msc.videoDisabled === "placeholder")
                return;
            msc.videoDisabled = !msc.videoDisabled;
        }
    }
    processRtpCapabilities(direction, rtpCapabilities) {
        return rtpCapabilities;
    }
    get userAgent() {
        var _a, _b;
        return (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : "<unknown ua>";
    }
    get userAgentData() {
        var _a;
        return (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.userAgentData;
    }
    async getUserAgentInfo() {
        var _a;
        const browser = bowser_1.default.getParser(this.userAgent);
        // Set default values based on UA-data
        this.platform = browser === null || browser === void 0 ? void 0 : browser.getOSName();
        this.appVersion = browser === null || browser === void 0 ? void 0 : browser.getBrowserVersion();
        this.browserName = browser === null || browser === void 0 ? void 0 : browser.getBrowserName();
        // Override to UserAgent Data
        if (this.userAgentData != null) {
            try {
                this.highEntropyValues = await this.userAgentData.getHighEntropyValues([
                    "brands",
                    "mobile",
                    "model",
                    "platform",
                    "platformVersion",
                    "fullVersionList",
                ]);
                this.platform = (_a = this.highEntropyValues.platform) !== null && _a !== void 0 ? _a : browser === null || browser === void 0 ? void 0 : browser.getOSName();
            }
            catch (err) {
                // log someting useful
            }
        }
        this.isIosDevice = (0, user_agent_1.isIosDevice)(this);
        this.isAndroidDevice = (0, user_agent_1.isAndroidDevice)(this);
        this.isMobileDevice = (0, user_agent_1.isMobileDevice)(this);
        this.isSafari = (0, user_agent_1.isSafari)(this);
        this.isFirefox = (0, user_agent_1.isFirefox)(this);
        this.isChrome = (0, user_agent_1.isChrome)(this);
        this.isEdge = (0, user_agent_1.isEdge)(this);
        this.isIE = (0, user_agent_1.isIE)(this);
        this.isWindows = (0, user_agent_1.isWindows)(this);
    }
    get browserInfo() {
        return {
            highEntropyValues: this.highEntropyValues,
            platform: this.platform,
            appVersion: this.appVersion,
            browserName: this.browserName,
            isIosDevice: this.isIosDevice,
            isAndroidDevice: this.isAndroidDevice,
            isMobileDevice: this.isMobileDevice,
            isSafari: this.isSafari,
            isFirefox: this.isFirefox,
            isChrome: this.isChrome,
            isEdge: this.isEdge,
            isIE: this.isIE,
            isWindows: this.isWindows,
        };
    }
    // End UserAgent Information
    // basic features
    get hidden() {
        var _a;
        return (_a = globalScope.document.hidden) !== null && _a !== void 0 ? _a : false;
    }
    get supportFullscreen() {
        const v = globalScope.document.createElement("video");
        const d = globalScope.document;
        return (globalScope.document.fullscreenEnabled === true ||
            d.mozFullScreenEnabled === true ||
            d.msFullscreenEnabled === true ||
            d.webkitSupportsFullscreen === true ||
            d.webkitFullscreenEnabled === true ||
            v.webkitRequestFullScreen != null ||
            v.webkitEnterFullScreen != null);
    }
    get onLine() {
        var _a, _b;
        return (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.onLine) !== null && _b !== void 0 ? _b : true;
    }
    get location() {
        return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) || null;
    }
    get permissions() {
        var _a;
        return (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.permissions;
    }
    get userActivation() {
        var _a;
        return ((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.userActivation) || null;
    }
    get maxTouchPoints() {
        var _a;
        return ((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.maxTouchPoints) || null;
    }
    addEventListener(type, listener) {
        if (globalScope.addEventListener != null) {
            globalScope.addEventListener(type, listener);
        }
    }
    removeEventListener(type, listener) {
        if (globalScope.removeEventListener != null) {
            globalScope.removeEventListener(type, listener);
        }
    }
    setInterval(fn, ms) {
        return globalScope.setInterval(fn, ms);
    }
    // optional features
    get console() {
        return globalScope.console;
    }
    fetch(uri, request) {
        return globalScope.fetch(uri, request);
    }
    get URLSearchParams() {
        return globalScope.URLSearchParams;
    }
    get AudioContext() {
        var _a;
        return (_a = globalScope.AudioContext) !== null && _a !== void 0 ? _a : globalScope.webkitAudioContext;
    }
    get MediaRecorder() {
        return globalScope.MediaRecorder;
    }
    get MediaStream() {
        return globalScope.MediaStream;
    }
    get WebSocketClient() {
        return globalScope.WebSocketClient;
    }
    get RTCRtpReceiver() {
        return globalScope.RTCRtpReceiver;
    }
    get RTCRtpSender() {
        return globalScope.RTCRtpSender;
    }
    get Uint8Array() {
        return globalScope.Uint8Array;
    }
    matchMedia(query) {
        return globalScope === null || globalScope === void 0 ? void 0 : globalScope.matchMedia(query);
    }
    get mediaDevices() {
        var _a;
        return (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.mediaDevices;
    }
    get connection() {
        var _a, _b, _c, _d, _e;
        return ((_d = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.connection) !== null && _b !== void 0 ? _b : (_c = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _c === void 0 ? void 0 : _c.mozConnection) !== null && _d !== void 0 ? _d : (_e = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _e === void 0 ? void 0 : _e.webkitConnection);
    }
    get localStorage() {
        return globalScope.localStorage;
    }
    get performance() {
        return globalScope.performance;
    }
    get screenOrientation() {
        var _a, _b, _c;
        const scr = globalScope.screen;
        return (_c = (_b = ((_a = scr.orientation) !== null && _a !== void 0 ? _a : {}).type) !== null && _b !== void 0 ? _b : scr.mozOrientation) !== null && _c !== void 0 ? _c : scr.msOrientation;
    }
    get MediaSource() {
        return globalScope.MediaSource || globalScope.WebKitMediaSource;
    }
    get WebSocket() {
        return globalScope.WebSocket;
    }
    get SourceBuffer() {
        return globalScope.SourceBuffer || globalScope.WebKitSourceBuffer;
    }
    // Hls.js
    get Hls() {
        return globalScope.Hls;
    }
    applyConstraints(track, constraints) {
        return track.applyConstraints(constraints);
    }
    createVideoElement() {
        const video = globalScope.document.createElement("video");
        video.autoplay = true;
        video.setAttribute("webkit-playsinline", "true");
        video.setAttribute("playsinline", "true");
        const fallbackText = globalScope.document.createTextNode("Sorry, your browser doesn't support embedded videos.");
        video.appendChild(fallbackText);
        return video;
    }
    createAudioElement() {
        const audio = globalScope.document.createElement("audio");
        return audio;
    }
    createCanvasElement() {
        const canvas = globalScope.document.createElement("canvas");
        return canvas;
    }
    createScreenshot(video) {
        const canvas = this.canvasElement;
        if (canvas == null)
            return "";
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL();
    }
    supportsMediaStreamCapture(el) {
        const support = (el === null || el === void 0 ? void 0 : el.mozCaptureStream) != null || (el === null || el === void 0 ? void 0 : el.captureStream) != null;
        if (!support) {
            this.logger.debug("mediaStreamCapture not supported");
        }
        return support;
    }
    captureStream(el, frameRate) {
        if (el.captureStream != null) {
            if ((0, api_1.isHTMLCanvasElement)(el)) {
                return el.captureStream(frameRate);
            }
            return el.captureStream();
        }
        /**
         * Firefox Polyfill
         */
        if (el.mozCaptureStream != null) {
            if ((0, api_1.isHTMLCanvasElement)(el)) {
                return el.mozCaptureStream(frameRate);
            }
            return el.mozCaptureStream();
        }
        this.logger.debug("mediaStreamCapture not supported");
        return null;
    }
    createVideoStub() {
        throw new Error("not implemented");
    }
    disableCpuStats() {
        // @todo: implement me
    }
    enableCpuStats() {
        // @todo: implement me
    }
    averageCpuUsage(interval) {
        return 0;
    }
    isCodecSupported(codec) {
        return false;
    }
    isHlsLoaded() {
        try {
            return this.Hls != null;
        }
        catch (err) {
            return false;
        }
    }
    loadHlsScript(path) {
        if (this.hlsPromise != null) {
            return this.hlsPromise;
        }
        if (this.isHlsLoaded()) {
            return Promise.resolve();
        }
        const newPath = path !== null && path !== void 0 ? path : HLSJS_URL;
        this.hlsPromise = new Promise((resolve, reject) => {
            // Add a timeout
            if (this.isHlsLoaded()) {
                resolve();
                return;
            }
            const script = globalScope.document.createElement("script");
            script.setAttribute("src", newPath !== null && newPath !== void 0 ? newPath : "");
            script.onload = () => {
                if (!this.isHlsLoaded()) {
                    reject(new Error("hlsjs not loaded"));
                }
                else {
                    resolve();
                }
            };
            script.onerror = (err) => {
                reject(new Error(`hlsjs not loaded: ${err}`));
            };
            globalScope.document.body.appendChild(script);
        });
        return this.hlsPromise;
    }
    get mpegts() {
        return globalScope.mpegts;
    }
    isMpegtsLoaded() {
        try {
            return this.mpegts != null;
        }
        catch (err) {
            return false;
        }
    }
    loadMpegtsScript(path) {
        if (this.mpegtsPromise != null) {
            return this.mpegtsPromise;
        }
        if (this.isMpegtsLoaded()) {
            return Promise.resolve();
        }
        const newPath = path !== null && path !== void 0 ? path : MPEGTS_URL;
        this.mpegtsPromise = new Promise((resolve, reject) => {
            // Add a timeout
            if (this.isMpegtsLoaded()) {
                resolve();
                return;
            }
            const script = globalScope.document.createElement("script");
            script.setAttribute("src", newPath !== null && newPath !== void 0 ? newPath : "");
            script.onload = () => {
                if (!this.isMpegtsLoaded()) {
                    reject(new Error("mpegts not loaded"));
                }
                else {
                    resolve();
                }
            };
            script.onerror = (err) => {
                reject(new Error(`mpegts not loaded: ${err}`));
            };
            globalScope.document.body.appendChild(script);
        });
        return this.mpegtsPromise;
    }
    // MediaRecorder feature
    showSaveFilePicker(options) {
        return globalScope === null || globalScope === void 0 ? void 0 : globalScope.showSaveFilePicker(options);
    }
    confirmMessage(message) {
        globalScope === null || globalScope === void 0 ? void 0 : globalScope.confirm(message);
    }
    get document() {
        return globalScope.document;
    }
    isImplements(feature) {
        var _a, _b;
        try {
            switch (feature) {
                case feature_1.Feature.NETWORK_INFORMATION:
                    return this.location != null;
                case feature_1.Feature.CREATE_VIDEO_ELEMENT:
                    return globalScope.document != null && this.createVideoElement != null;
                case feature_1.Feature.CREATE_AUDIO_ELEMENT:
                    return globalScope.document != null && this.createAudioElement != null;
                case feature_1.Feature.CREATE_CANVAS_ELEMENT:
                    return globalScope.document != null && this.createCanvasElement != null;
                case feature_1.Feature.CREATE_SCREENSHOT:
                    return ((_a = this.canvasElement) === null || _a === void 0 ? void 0 : _a.getContext) != null;
                case feature_1.Feature.DEBUGGING:
                    return this.console != null && this.performance != null;
                case feature_1.Feature.DOCUMENT:
                    return this.document != null;
                case feature_1.Feature.SCREEN_ORIENTATION:
                    return this.screenOrientation != null;
                case feature_1.Feature.MEDIA_RECORDER:
                    return this.MediaRecorder != null;
                case feature_1.Feature.APPLY_CONSTRAINTS:
                    return true;
                case feature_1.Feature.MEDIA_DEVICE:
                    return this.mediaDevices != null;
                case feature_1.Feature.MATCH_MEDIA:
                    return this.matchMedia != null;
                case feature_1.Feature.MEDIA_STREAM:
                    return this.MediaStream != null;
                case feature_1.Feature.MEDIA_SOURCE:
                    return this.MediaSource != null && this.SourceBuffer != null;
                case feature_1.Feature.WEB_SOCKET:
                    return this.WebSocket != null;
                case feature_1.Feature.WEB_SOCKET_CLIENT:
                    return this.WebSocket != null;
                case feature_1.Feature.LOCAL_STORAGE:
                    try {
                        return this.localStorage != null;
                    }
                    catch (err) {
                        return false;
                    }
                case feature_1.Feature.AUDIO_CONTEXT:
                    return this.AudioContext != null;
                case feature_1.Feature.URL_LOCATION:
                    return this.location != null;
                case feature_1.Feature.URL_SEARCHPARAMS:
                    return this.URLSearchParams != null;
                case feature_1.Feature.CPU_USAGE:
                    return false;
                case feature_1.Feature.HLSJS:
                    return true;
                case feature_1.Feature.PERMISSIONS:
                    return this.permissions != null;
                case feature_1.Feature.USER_ACTIVATION:
                    return this.userActivation != null;
                case feature_1.Feature.USER_AGENT_DATA:
                    return this.userAgentData != null;
                case feature_1.Feature.MULTI_TOUCH:
                    return this.maxTouchPoints != null && this.maxTouchPoints > 1;
                case feature_1.Feature.WEBRTC:
                    return ((_b = this.RTCRtpReceiver) === null || _b === void 0 ? void 0 : _b.getCapabilities) != null && this.RTCRtpSender != null;
                case feature_1.Feature.MPEGTS:
                    return true;
                default:
                    return false;
            }
        }
        catch (err) {
            if (err instanceof NotSupportedError) {
                return false;
            }
            throw err;
        }
    }
}
exports.WebDevice = WebDevice;
WebDevice.displayName = "WebDevice";
//# sourceMappingURL=web-device.js.map